// extracted by mini-css-extract-plugin
module.exports = {"container":"EmbeddedHtml_container__1BBa3","htmlContainer":"EmbeddedHtml_htmlContainer__kD2Gy"};